var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoginOrSignUpPage
    ? _c("footer", { staticClass: "c-site-footer" }, [_vm._m(0)])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "l-wrap" }, [
      _c("div", { staticClass: "footer-logo" }, [
        _c("a", { attrs: { href: "/" } }, [
          _c("img", {
            attrs: {
              src: "/static/images/cesppa-blue-logo.svg",
              alt: "Footer Logo",
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v("\n      © Inspectiv 2021. All Rights Reserved.\n      "),
        _c("br"),
        _vm._v(" "),
        _c(
          "a",
          { attrs: { href: "https://www.inspectiv.com/PrivacyPolicy.html" } },
          [_vm._v("Privacy Policy")]
        ),
        _vm._v(" |\n      "),
        _c(
          "a",
          { attrs: { href: "https://www.inspectiv.com/TermsOfUse.html" } },
          [_vm._v("Terms & Conditions")]
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }